import { render, staticRenderFns } from "./SmartMatching.vue?vue&type=template&id=9dea74c2&scoped=true"
import script from "./SmartMatching.vue?vue&type=script&lang=js"
export * from "./SmartMatching.vue?vue&type=script&lang=js"
import style0 from "./SmartMatching.vue?vue&type=style&index=0&id=9dea74c2&prod&lang=scss&scoped=true"
import style1 from "./SmartMatching.vue?vue&type=style&index=1&id=9dea74c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dea74c2",
  null
  
)

export default component.exports